import React, { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles, ExternalLink } from "lucide-react";
import { useLang } from "@/context/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SponsorCard = () => {
  const { t } = useLang();
  const [sp, setSp] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sponsor`).then((r) => setSp(r.data)).catch(() => {});
  }, []);

  if (!sp || !sp.is_active || !sp.title) return null;

  const Inner = (
    <div className="flex items-center gap-4">
      {sp.logo_url ? (
        <img src={sp.logo_url} alt={sp.title} className="w-14 h-14 rounded-2xl object-contain shrink-0 p-1.5" style={{ background: "#fff", border: "1px solid var(--border)" }} />
      ) : (
        <span className="grid place-items-center w-12 h-12 rounded-2xl shrink-0" style={{ background: "var(--brass-light)", color: "var(--accent)" }}>
          <Sparkles size={22} />
        </span>
      )}
      <div className="min-w-0">
        <p className="font-ui text-xs font-bold uppercase tracking-widest" style={{ color: "var(--accent)" }}>{t("sp_by")}</p>
        <p className="font-ui text-lg font-bold truncate" style={{ color: "var(--text)" }}>{sp.title}</p>
        {sp.message && <p className="font-ui text-sm truncate" style={{ color: "var(--text-muted)" }}>{sp.message}</p>}
      </div>
      {sp.link && <ExternalLink size={18} className="ml-auto shrink-0" style={{ color: "var(--text-muted)" }} />}
    </div>
  );

  const cls = "block rounded-3xl p-5 sm:p-6 transition-transform hover:scale-[1.01]";
  const style = { background: "var(--card)", border: "1px dashed var(--accent)" };

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-10" data-testid="sponsor-card">
      {sp.link ? (
        <a href={sp.link} target="_blank" rel="noreferrer" className={cls} style={style} data-testid="sponsor-link">{Inner}</a>
      ) : (
        <div className={cls} style={style}>{Inner}</div>
      )}
    </section>
  );
};
